<template>
	<div id="content">
        <div class="box">
            <div class="row">
                <div class="col-10">
                    <e-select
                        v-model="duplicate_selected"
                        id="horseDuplicate"
                        :placeholder="$t('table.tables.search_duplicate')"
                        :selectedLabel="$t('global.selected_label')"
                        :options="all_duplicate"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        track-by="code"
                        label="label"
                    >
                        <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                    </e-select>
                </div>
                <div class="col-2">
                    <b-button variant="primary" block @click="search" :disabled="!duplicate_selected">{{ $t("global.rechercher") }}</b-button>
                </div> 
                <div class="col-12">
                    <CustomTable
                        id_table="horse_search_duplicate"
                        primaryKey="horse_id"
                        :hrefsRoutes="config_table_hrefs"
                        :items="horses"
                        :busy.sync="table_busy"
                    />
                </div>
            </div>
        </div>
	</div>
</template>

<script type="text/javascript">
    import Horse from "@/mixins/Horse.js"
  
	export default {
		name: "HorseSearchDuplicate",
		mixins: [Horse],
		data () {
			return {
                duplicate_selected: '',
                table_busy: false,
                horses:[],
                config_table_hrefs: {
                    'horse_nom': {
                        routeUniqueName: 'horseFiche',
                        routeName: 'horseFiche',
                        params: {
                            horse_id: 'horse_id'
                        }
                    }
                },
                all_duplicate: [{
					code: 'horse_nom',
					label: this.getTrad('table.horse_search_duplicate.horse_nom')
				},{
					code: 'horse_sire',
					label: this.getTrad('table.horse_search_duplicate.horse_wholesire')
				},{
					code: 'horse_ueln',
					label: this.getTrad('table.horse_search_duplicate.horse_ueln')
				},{
					code: 'horse_transpondeur',
					label: this.getTrad('table.horse_search_duplicate.horse_transpondeur')
				}],

			}
		}, 
		mounted() {
            this.init_component()
        },
        methods: {
            async init_component() {
            	
			},

            async search() {
                this.table_busy = true
                this.horses = await this.searchDuplicate(this.duplicate_selected.code)
                this.table_busy = false
              
            }

        },
		components: {
			CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
		}
	}
</script>
